/** 
 * [Ref] - Denotes Pseudo Code Reference
 * Author: Sushmitha M
 * Crated Date: 08/11/2020
 * 
 * Ref: SC_PC_73
 * Import the necessary node-modules. If any of the nodes modules are not avaialble then 
 * install the node modules using the npm install command.
 * 
*/
import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';

class ShoppingCartStore extends EventEmitter {
    getlatlongresp = "";
    CartitemList = "";
    UpdateMessage = "";
    UpdateMessageOL = "";
    FavItemDetailsAry = "";
    FavItemUpdateAry = "";
    deleteItemAry = "";
    PlaceOrderMsge = "";
    OrderPDFMsge = "";
    quickItemcheck = "";
    attachmentResponse = "";
    removeAttachmentResponse = "";
    CancelOrderMsge = "";
    NONCAT_UploadAttachments = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    currentFavPageResponse = "";
    WarehouseIcon = "";
    /*[03/16/22,WAL-721_PC_10,WAL-721], Priyanka D */
    ReorderResponse = "";
    graingerdata = "";/*********NEW******wal-158*****/
    FeedbackResponse = "";
    HALLocData = "";
    ZipcodeValidation = "";
    /**
   * Ref: SC_PC_74
   * 
   * Declare the store call that extends "EventsEmitter"
   * Handle the response from action to component
   */
    handleShoppingCartStore = (action) => {
        switch (action.action.type) {
            case "Cartitem": {
                this.CartitemList = action.action.response;
                this.emit('Cartitem');
                break;
            }
            case "HostedSuccessfully": {
                this.hostedResponse = action.action.response;
               // console.error("storeDivis", action.action.response);
                this.emit('HostedSuccessfully');
                break;
            }
            case "latlongresp": {
                this.getlatlongresp = action.action.response;
                this.emit('latlongresp');
                break;
            }
            case "UpdateStatus": {
                this.UpdateMessage = action.action.response;
                this.emit('UpdateStatus');
                break;
            }
            case "UpdateStatusOL": {
                this.UpdateMessageOL = action.action.response;
                this.emit('UpdateStatusOL');
                break;
            }
            case "FavItemDetails": {
                this.FavItemDetailsAry = action.action.response;
                this.emit('FavItemDetails');
                break;
            }
            case "FavItemUpdate": {
                this.FavItemUpdateAry = action.action.response;
                this.emit('FavItemUpdate');
                break;
            }
            //Google API -Zipcode validation WW-748/782 Pavitha [4/24/2024] 
            case "Zipcode_Validation": {
                this.ZipcodeValidation = action.action.response;
                this.emit('Zipcode_Validation');
                break;
            }
            case "deleteItem": {
                this.deleteItemAry = action.action.response;
                this.emit('deleteItem');
                break;
            }
            case "PlaceOrder": {
                this.PlaceOrderMsge = action.action.response;
                this.emit('PlaceOrder');
                break;
            }
            case "CancelOrder": {
                this.CancelOrderMsge = action.action.response;
                this.emit('CancelOrder');
                break;
            }
            case "OrderPDF": {
                this.OrderPDFMsge = action.action.response;
                this.emit('OrderPDF');
                break;
            }
            case "ShopCart_QuickItemCheck": {
                this.quickItemcheck = action.action.response;
                this.emit('quickItemCheck');
                break;
            }
            case "ShopCart_UploadAttachments": {
                this.attachmentResponse = action.action.response;
                this.emit('attachmentResponse');
                break;
            }
            case "ShopCart_RemoveAttachment": {
                this.removeAttachmentResponse = action.action.response;
                this.emit('rmvAttach');
                break;
            }
            case "ShopCart_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "ShopCart_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "ShopCart_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
            case "HALocations": {
                this.HALLocData = action.action.response;
                this.emit('HALocations');
                break;

            }
            case "grainger": {
                this.graingerdata = action.action.response;
                this.emit('grainger');
                break;
            }
            case "workordercheck": {
                this.workorderresponse = action.action.response;
                this.emit('workordercheck');
                break;
            }
            case "workorderfail": {
                this.workorderresponse = "fail";
                this.emit('WOfail');
                break;

            }
            case "ShoppingCart_DeleteFavItem": {
                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('DelFavPage');
                break;
            }
            case "WarehouseQty": {
                this.workorderresponse = action.action.response;
                this.emit('Warehousecheck');
                break;
            }
            //[2/16/22], WW-330, Dhevanesam R
            case "WarehouseIcon": {
                this.WarehouseIcon = action.action.response;
                this.emit('WarehouseIcon');
                break;
            }
            /*[03/16/22,WAL-721_PC_10,WAL-721], Priyanka D */
            case "ReorderResponse": {
                
                this.ReorderResponse = action.action.response;
                this.emit('ReorderResponse');
                break;
            }
            case "NONCAT_UploadAttachments1": {
                
                this.NONCAT_UploadAttachments1 = action.action.response;
                this.emit('NONCAT_UploadAttachments1');
                break;
            }
            case "NONCAT_RemoveAttachment_Fav_Ord": {
                this.removeAttachmentResponse = action.action.response;
                this.emit('favorderrmvAttact');
                break;
            }
            /*'[10/04/22,WW-521_17], Priyanka D */
            case "RatingSubmissionresponse": {
                this.removeAttachmentResponse = action.action.response;
                this.emit('FeedbackResponse');
                break;
            }

        }
    }

}

const objShoppingCartStore = new ShoppingCartStore;
Dispatcher.register(objShoppingCartStore.handleShoppingCartStore.bind(objShoppingCartStore));
export default objShoppingCartStore;